import React from 'react'
import { Upload, Icon, Modal, Tooltip } from 'antd';
const Dragger = Upload.Dragger

class Uploader extends React.Component {
  state = {
    previewVisible: false,
    previewImage: '',
    fileList: [
      //   {
      //   uid: -1,
      //   name: 'xxx.png',
      //   status: 'done',
      //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
      // }
    ],
  };
  componentWillReceiveProps = (nextProps)=> { //or defaultFileList?
    nextProps.photo && this.setState({ fileList:[
      {
        uid: -1,
        name: 'xxx.png',
        status: 'done',
        url: nextProps.photo.image_url,
      }
    ] })

  }
  handleCancel = () => this.setState({ previewVisible: false })

  handlePreview = (file) => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true,
    });
  }

  // handleChange = ({ fileList }) => this.setState({ fileList: fileList.map(({error, ...f})=>({...f})) })
  handleChange = ({ fileList }) => this.setState({ fileList })

  render() {


    const { previewVisible, previewImage, fileList, test } = this.state;
    const uploadButton = (
      <div className="uploadButton">
        <Tooltip title={this.props.tooltipTitle || `Drag and drop or click to upload your photos. `}>
          <Icon type="camera"/>
          {/* <div className="ant-upload-text">Upload</div> */}
          <h2>Photo</h2>
        </Tooltip>
      </div>
    );
    return (
      <div className="Uploader">
        <Dragger
          action="//everlance"
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
          onRemove={()=>this.props.beforeUpload(null)}
          beforeUpload={ (file) => {
            // this.setState(({ fileList }) => ({
            //   fileList: [...fileList, file],
            // }));
            this.props.beforeUpload(file)
            return true;
          }}


        >
          {fileList.length >= 1 ? null : uploadButton}
        </Dragger>
        <Modal width="80vw" visible={previewVisible} footer={null} onCancel={this.handleCancel}>
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    );
  }
}

export default Uploader



// WEBPACK FOOTER //
// ./src/core/Uploader.js